import { InfoIcon } from "lucide-react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip"

export const TooltipInfo = ({description}: {description: string}) => {
    return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger><InfoIcon className="size-4 cursor-help" /></TooltipTrigger>
        <TooltipContent className="max-w-[500px]">
          <p>{description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
} 